var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, Divider } from "@mui/material";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import dayjs from "dayjs";
export var getProductDetailsCard = function (lgMode) {
    return [{
            type: FormItemTypes.CardComponent,
            name: "Product Details",
            label: "Product Details",
            columnSize: 12,
            sx: {
                border: '1px',
                borderRadius: "12px",
                borderColor: "secondary.200"
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: "",
                    label: "",
                    columnSize: 12,
                    sx: {
                        backgroundColor: 'secondary.50'
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: 'Product details Mob',
                            columnSize: 12,
                            spacing: 0,
                            elements: __spreadArray([], [{
                                    label: 'Supplier',
                                    fieldName: 'AssignedEmployeeId'
                                }, {
                                    label: 'Plant',
                                    fieldName: 'PlantName',
                                    fieldCode: 'PlantCode',
                                    divider: true
                                }, {
                                    label: 'Group',
                                    fieldName: 'ProductGroupName',
                                    fieldCode: 'ProductGroupCode',
                                    divider: true
                                }, {
                                    label: 'Product',
                                    fieldName: 'ModelName',
                                    fieldCode: 'ModelCode',
                                    divider: true
                                }, {
                                    label: 'Vehicle manufacturing date',
                                    fieldName: 'DateOfMfg',
                                    date: true
                                }].map(function (item) { return item !== null && item !== void 0 && item.divider ? {
                                type: FormItemTypes.Typography,
                                label: item.label,
                                name: item.fieldName,
                                disabled: true,
                                setFieldProps: function (formValues, currValue, field) {
                                    return {
                                        type: FormItemTypes.Typography,
                                        children: /*#__PURE__*/ React.createElement(Box, {
                                            sx: {
                                                ml: {
                                                    xs: 10,
                                                    sm: '0px',
                                                    md: '0px'
                                                },
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                width: '70%'
                                            }
                                        }, /*#__PURE__*/ React.createElement(Box, {
                                            sx: {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }
                                        }, formValues[item.fieldName] || '-'), /*#__PURE__*/ React.createElement(Divider, {
                                            orientation: "vertical",
                                            flexItem: true,
                                            sx: {
                                                borderColor: 'text.tertiary',
                                                height: '16px',
                                                alignSelf: 'center'
                                            }
                                        }), /*#__PURE__*/ React.createElement(Box, {
                                            sx: {
                                                whiteSpace: 'nowrap'
                                            }
                                        }, formValues[item === null || item === void 0 ? void 0 : item.fieldCode] || '-')),
                                        labelTypographyProps: {
                                            mb: {
                                                xs: '0px',
                                                sm: '4px',
                                                md: '4px'
                                            },
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        containerProps: {
                                            display: 'flex',
                                            direction: {
                                                xs: 'row',
                                                sm: 'column',
                                                md: 'column'
                                            },
                                            justifyContent: {
                                                xs: 'space-between',
                                                sm: 'normal'
                                            }
                                        }
                                    };
                                },
                                xs: 12,
                                sm: 6,
                                md: 3
                            } : {
                                // Desktop view
                                type: FormItemTypes.Typography,
                                label: item.label,
                                name: item.fieldName,
                                disabled: true,
                                pb: {
                                    xs: 0,
                                    sm: 1,
                                    md: 1
                                },
                                xs: 12,
                                sm: 6,
                                md: 3,
                                labelTypographyProps: {
                                    mb: {
                                        xs: '0px',
                                        sm: '4px',
                                        md: '4px'
                                    },
                                    noWrap: true,
                                    fontWeight: 'medium',
                                    fontSize: 'sm'
                                },
                                containerProps: {
                                    display: 'flex',
                                    direction: {
                                        xs: 'row',
                                        sm: 'column',
                                        md: 'column'
                                    },
                                    justifyContent: {
                                        xs: 'space-between',
                                        sm: 'normal'
                                    }
                                },
                                valueGetter: function (formValues, field) {
                                    var _field$name, _field$name2;
                                    return item !== null && item !== void 0 && item.date ? formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']).format('DD MMM, YYYY') : '-' : (formValues === null || formValues === void 0 ? void 0 : formValues[item.fieldName]) || '-';
                                }
                            }; }), true)
                        }]
                }]
        }];
};
